var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step_container"},_vm._l((_vm.list),function(item,idx){return _c('div',{key:idx,staticClass:"step",class:{active_step:item.idx==_vm.current}},[_vm._v(_vm._s(item.idx)+"、"+_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }